import { onBeforeUnmount, onMounted, ref } from "vue";

export const MOBILE_BREAKPOINT = 960;

/** Share the shell breakpoint without replacing page state when the viewport changes. */
export function useMobileLayout() {
  const isMobile = ref(typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT);
  const update = () => { isMobile.value = window.innerWidth <= MOBILE_BREAKPOINT; };
  onMounted(() => window.addEventListener("resize", update));
  onBeforeUnmount(() => window.removeEventListener("resize", update));
  return { isMobile };
}
